export default {
  root: {
    borderBottom: 0,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  body: {
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0
  }
};
